<template>
  <div v-if="!isMobileApp">
    <Dropdown dropdownContentAlign="right">
      <template v-slot:toggle>
        <slot>
          <i class="cursor-pointer sr-2 sr-v2-share" :class="`${textStyles.sizes[size]} ${textStyles.colors[color]}`" />
        </slot>
      </template>
      <template v-slot:content>
        <div class="flex flex-col px-3 py-2 font-normal text-black">
          <a
            :href="twitterShareLink"
            target="_blank"
            rel="noopener noreferrer nofollow"
            class="pb-2 ds-text-sm text-gray-1000"
          >
            <i class="sr-2 sr-v2-twitter" /> Share on X
          </a>

          <a
            class="ds-text-sm text-gray-1000"
            :href="facebookShareLink"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            <i class="sr-2 sr-v2-facebook" /> Share on Facebook
          </a>
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { Dropdown } from '@sportsrecruits/playbook';
import { dsTextSizes } from '@/srui'
import SRCookies from '@/services/cookies'
export default {
  components: {
    Dropdown
  },
  data() {
    return {
      isOpen: false,
      textStyles: {
        sizes: {
          ...dsTextSizes
        },
        colors: {
          'blue': 'text-blue-300'
        }
      }
    };
  },
  props: {
    size: { required: false, default: "2xl", type: String },
    color: { required: false, default: "blue", type: String },
    text: {
      required: false,
      default: "Check out this link from SportsRecruits:",
      type: String
    },
    link: { required: true, type: String }
  },
  methods: {
    close() {
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    }
  },
  computed: {
    facebookShareLink: function() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.link}`;
    },
    twitterShareLink: function() {
      return `https://twitter.com/share?url=${this.link}&text=${this.text}`;
    },
    isMobileApp() {
          return SRCookies.isMobileSession()
    },
  }
};
</script>

<style scoped>
.fb-background-color {
  background-color: #3b5998;
}

.twitter-background-color {
  background-color: #1da1f2;
}
</style>
